module.exports = __webpack_public_path__ + "img/table-tennis.79f29a4e.svg";